module.exports = __webpack_public_path__ + "img/nestinari-fire.81e169ce.jpg";